<template>
  <div id="app">
      <router-view v-if="isLogined"></router-view>
    <!-- <demo v-if="isLogined" /> -->
    <div v-else class="oasis-login-tips">
      <p>用户没有登录，请先登录</p>
    </div>

  </div>
</template>

<script>
import demo from "./views/demo/index.vue";
// import { getCookie } from "./utils/cookie";

export default {
  name: "App",
  components: {
    demo,
  },
  data() {
    return {
      isLogined: false,
    };
  },
  created() {
    this.isLogined = true;
    // const env = process.env.BUILD_ENV;
    // if (env !== "development" && !getCookie("oasisSessionId")) {
    //   this.isLogined = false;
    //   location.href = `/resources/?oasisRedirectUrl=${encodeURIComponent(location.href)}`;
    // }
  },
  methods: {},
};
</script>

<style lang="scss">
#app {
  /* background-color: #ccc; */
  font-family: PingFang SC;
  padding-top: 56px;
}
.el-breadcrumb__item:last-child .el-breadcrumb__inner,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a,
.el-breadcrumb__item:last-child .el-breadcrumb__inner a:hover,
.el-breadcrumb__item:last-child .el-breadcrumb__inner:hover {
  font-weight: 400;
  color: inherit !important;
  cursor: text;
}

.el-select {
  // width: 100% !important;
}
.el-tree-node__content {
  height: 32px;
  line-height: 32px;
}
.el-tree-node__label {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  margin-right: 16px;
}
.el-tree--highlight-current .el-tree-node.is-current > .el-tree-node__content {
  background-color: #f6fafb !important;
  color: #2c797f;
  font-size: 12px;
}
.el-input:hover {
  // border: 1px solid #2c797f !important;

}
.el-tree-node__content:hover {
    background-color:#f6fafb !important;
}
.el-input__inner {
  height: 30px !important;
  line-height: 30px !important;
  border-radius: 0 !important;
  border: 1px solid #e8e8e8 !important;
  /* background-color: #F5F5F5 !important; */
}
.el-input__icon {
  line-height: 30px !important;
}
input:focus {
  /* border: 1px solid #F5F5F5 !important; */
}
.el-input.is-disabled .el-input__inner {
  background-color: #f5f5f5 !important;
  /* border-color: #E4E7ED;
    color: #C0C4CC;
    cursor: not-allowed; */
}
.oasis-login-tips {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
